"use client";

import { c as _c } from "react/compiler-runtime";
import React, { memo, useRef, useState } from "react";
import { useClickAway } from "react-use";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import { useIdentity } from "@/hooks/useIdentity";
import { EllipsisVerticalIcon, UserCircleIcon } from "@heroicons/react/24/outline";
import DropPfp from "@/components/drops/create/utils/DropPfp";
import { DropPartSize } from "@/components/drops/view/part/DropPart";
import UserLevel from "@/components/user/utils/level/UserLevel";
import HeaderUserConnect from "@/components/header/user/HeaderUserConnect";
import HeaderUserProxyDropdown from "@/components/header/user/proxy/HeaderUserProxyDropdown";
import { isEthereumAddress, isAutoGeneratedHandle } from "@/helpers/AllowlistToolHelpers";
interface WebSidebarUserProps {
  readonly isCollapsed: boolean;
  readonly profile: any;
}
function WebSidebarUser(t0) {
  const $ = _c(39);
  const {
    isCollapsed,
    profile: parentProfile
  } = t0;
  const [showUserMenu, setShowUserMenu] = useState(false);
  const {
    address,
    seizeConnect
  } = useSeizeConnectContext();
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  let t1;
  if ($[0] !== showUserMenu) {
    t1 = event => {
      if (showUserMenu && buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        setShowUserMenu(false);
      }
    };
    $[0] = showUserMenu;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useClickAway(dropdownRef, t1);
  const t2 = address || "";
  let t3;
  if ($[2] !== t2) {
    t3 = {
      handleOrWallet: t2,
      initialProfile: null
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    profile: localProfile,
    isLoading
  } = useIdentity(t3);
  const profile = parentProfile || localProfile;
  if (!address) {
    let t4;
    if ($[4] !== isCollapsed || $[5] !== seizeConnect) {
      t4 = <div className="tw-mt-auto tw-relative tw-w-full tw-group tw-pb-2 tw-px-3">{isCollapsed ? <button className="tw-w-full tw-block tw-no-underline tw-rounded-xl tw-border-none tw-transition-colors tw-duration-200 tw-h-12 tw-cursor-pointer focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-iron-500 focus-visible:tw-ring-offset-2 tw-font-medium tw-text-base tw-px-2 tw-text-iron-400 tw-bg-transparent desktop-hover:hover:tw-text-white active:tw-bg-transparent" onClick={() => seizeConnect()} title="Connect Wallet" data-tooltip-id="sidebar-tooltip" data-tooltip-content="Connect Wallet"><div className="tw-flex tw-items-center tw-w-full tw-h-full"><div className="tw-w-10 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0"><UserCircleIcon className="tw-h-6 tw-w-6 tw-flex-shrink-0" /></div></div></button> : <div className="tw-w-full tw-px-2 tw-mt-2"><div className="[&>button]:tw-w-full"><HeaderUserConnect /></div></div>}</div>;
      $[4] = isCollapsed;
      $[5] = seizeConnect;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  if (isLoading || !profile) {
    const t4 = `tw-flex tw-items-center tw-w-full tw-rounded-xl tw-py-2 tw-px-2 ${isCollapsed ? "tw-justify-center" : "tw-justify-start tw-gap-x-3"}`;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-h-10 tw-w-10 tw-rounded-lg tw-bg-iron-800 tw-animate-pulse tw-flex-shrink-0" />;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== isCollapsed) {
      t6 = !isCollapsed && <div className="tw-flex tw-flex-col tw-gap-y-2 tw-flex-1"><div className="tw-h-4 tw-w-24 tw-bg-iron-800 tw-rounded tw-animate-pulse" /><div className="tw-h-3 tw-w-16 tw-bg-iron-800 tw-rounded tw-animate-pulse" /></div>;
      $[8] = isCollapsed;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    let t7;
    if ($[10] !== t4 || $[11] !== t6) {
      t7 = <div className="tw-mt-auto tw-relative tw-w-full tw-group tw-pb-2 tw-px-3"><div className={t4}>{t5}{t6}</div></div>;
      $[10] = t4;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    return t7;
  }
  const displayHandle = profile.handle || address || "";
  let t4;
  if ($[13] !== address) {
    t4 = address && (isEthereumAddress(address) || isAutoGeneratedHandle(address));
    $[13] = address;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  const shouldTruncate = t4;
  let t5;
  if ($[15] !== showUserMenu) {
    t5 = () => setShowUserMenu(!showUserMenu);
    $[15] = showUserMenu;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = `tw-mt-1 tw-group/user tw-py-2 tw-px-2 tw-border-none tw-bg-transparent tw-w-full tw-rounded-xl tw-text-sm tw-font-semibold tw-text-white tw-transition-colors tw-duration-200 ${isCollapsed ? "" : "desktop-hover:hover:tw-bg-iron-900"}`;
  const t7 = `tw-flex tw-items-center tw-w-full ${isCollapsed ? "" : "tw-gap-x-2"}`;
  let t8;
  if ($[17] !== profile.pfp) {
    t8 = <div className="tw-w-10 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0"><DropPfp pfpUrl={profile.pfp} size={DropPartSize.MEDIUM} /></div>;
    $[17] = profile.pfp;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== displayHandle || $[20] !== isCollapsed || $[21] !== profile.level || $[22] !== shouldTruncate) {
    t9 = !isCollapsed && <><div className="tw-flex tw-flex-col tw-items-start tw-justify-between tw-min-w-0 tw-flex-1 tw-whitespace-nowrap"><div className={`tw-text-white tw-font-medium tw-text-md tw-leading-tight tw-w-full tw-text-left tw-overflow-hidden -tw-mt-0.5 tw-mb-1 ${shouldTruncate ? "tw-max-w-[8rem] tw-truncate" : ""}`}>{displayHandle}</div><UserLevel level={profile.level} size="xxs" asSpan={true} /></div><EllipsisVerticalIcon className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-400 group-hover/user:tw-text-white" /></>;
    $[19] = displayHandle;
    $[20] = isCollapsed;
    $[21] = profile.level;
    $[22] = shouldTruncate;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t10 = <div className={t7}>{t8}{t9}</div>;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== showUserMenu || $[29] !== t10 || $[30] !== t5 || $[31] !== t6) {
    t11 = <button ref={buttonRef} onClick={t5} className={t6} aria-label="Open user menu" aria-expanded={showUserMenu} aria-controls="user-menu">{t10}</button>;
    $[28] = showUserMenu;
    $[29] = t10;
    $[30] = t5;
    $[31] = t6;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== profile || $[34] !== showUserMenu) {
    t12 = showUserMenu && profile && <div ref={dropdownRef}><HeaderUserProxyDropdown profile={profile} isOpen={showUserMenu} onClose={() => setShowUserMenu(false)} /></div>;
    $[33] = profile;
    $[34] = showUserMenu;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  let t13;
  if ($[36] !== t11 || $[37] !== t12) {
    t13 = <div className="tw-mt-auto tw-relative tw-w-full tw-group tw-pb-2 tw-px-3">{t11}{t12}</div>;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
}
export default memo(WebSidebarUser);